import { render, staticRenderFns } from "./group-statuses.vue?vue&type=template&id=042dd60c"
import script from "./group-statuses.vue?vue&type=script&lang=js"
export * from "./group-statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports